<a
  class="flex px-2 py-1.5 items-center self-stretch hover:bg-primary-800 hover:rounded-lg justify-between"
  [class.gap-3]="!(sidebarService.$collapsed | async)"
  [class.w-52]="!(sidebarService.$collapsed | async)"
  [class.w-9]="sidebarService.$collapsed | async"
  [routerLink]="!hasContent ? link : null"
  (click)="!hasContent ? null : toggleExpand()"
  routerLinkActive="bg-primary-800 rounded-lg"
  [routerLinkActiveOptions]="{ exact: true }"
  [class.cursor-pointer]="icon"
  [class.pointer-events-none]="isAnimating"
  [class.disable-active]="isAnimating">
  <ng-contrainer *ngIf="!!icon" [ngSwitch]="icon">
    <span class="flex-shrink-0">
      <app-icon-wrapper [color]="'white'" [icon]="icon" [size]="'medium'" />
    </span>
  </ng-contrainer>
  <span
    [class.pl-1]="(sidebarService.$collapsed | async) && !icon"
    [class.ml-custom]="(sidebarService.$collapsed | async) && !icon"
    [class.ml-8]="!icon && !(sidebarService.$collapsed | async)"
    class="text-white text-base font-normal flex-1 h-6">
    {{
      (sidebarService.$collapsed | async)
        ? !icon
          ? getFirstLetter(label)
          : ''
        : label
    }}
  </span>
  <ng-container *ngIf="!(sidebarService.$collapsed | async) && hasContent">
    <app-icon-wrapper
      [color]="'white'"
      [icon]="isExpanded ? 'chevron-up' : 'chevron-down'" />
  </ng-container>
</a>
<div
  [class.max-h-0]="!isExpanded"
  [class.max-h-96]="isExpanded"
  class="overflow-hidden transition-all duration-400 ease-in-out">
  <ng-content></ng-content>
</div>
